<template>
    <div id="DetalleDeDocumento_div" class="w-100 px-0 py-0">
        <div id="TituloDetalleDeDocumento_div">
            <h5 class="label-black" style="margin-bottom: 0px;">REPORTES</h5>
            <h6 class="label-black" style="margin-top: 0px;">Reporte de Solicitudes</h6>
        </div>
        <div class="row d-flex">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">
                <div class="area custom-area" style="margin-top: 0px">
                    <div class="row">
                            <div class="form-group col-4" id="Busqueda_div">
                                <label class="label-black">Área:</label>
                                <CAreas
                                v-on:valorParaElPadre="cambioDeArea" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'catalogoAreas'" 
                                :parametros="parametros_Area" 
                                :valorDefinido="parametros_Area.areaId" 
                                :key="parametros_Area.areaId"
                                >
                                </CAreas>
                            </div>
                            <div class="form-group col-2">
                                <label class="label-black">Año:</label>
                                <input class="form-control" type="Number" v-model="Busqueda.Anio">
                            </div>
                            <div class="form-group col-1" style="margin-top: 26px;">
                                <button class="btn btn-sm btn-custom" @click='ObtenerReporte()'>Generar Reporte</button>
                            </div>
                    </div>
                </div>
                <div class="area custom-area" id="resultado_div" v-if="SolicitudArea.length > 0 || Sedes.length > 0 || Totales.length>0">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#Juzgado" role="tab" aria-controls="Juzgado" aria-selected="true">Solicitudes del Juzgado</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Publicas" role="tab" aria-controls="Publicas" aria-selected="false">Solicitudes Públicas</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#Totales" role="tab" aria-controls="Totales" aria-selected="false">Solicitudes Todas las Áreas</a>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="Juzgado" role="tabpanel" aria-labelledby="home-tab">
                            <div id="Resultado_Juzgado_id">
                                <br>
                                <div v-if="SolicitudArea.length > 0" style="width:100%;height:100%;">
                                <TSolicitudesArea 
                                :Datos= this.SolicitudArea 
                                :EtiquetaArea= this.Etiqueta.AreaReporte 
                                :EtiquetaAnio= this.Etiqueta.AnioReporte
                                :Ingreso = false
                                :Solicitud = true
                                :HNombre= this.headName
                                :ShowGrafica = true></TSolicitudesArea>
                                </div>
                                <br>
                                <div v-if="Sedes.length > 0" style="width:100%;height:100%;">
                                    <TSedes
                                    :Datos= this.Sedes 
                                    :EtiquetaArea = this.NombreSede
                                    :EtiquetaAnio = this.Etiqueta.AnioReporte
                                    :Ingreso = false
                                    :Solicitud = true
                                    :HNombre= this.NombreSede
                                    :ShowGrafica = false></TSedes>
                                </div>
                                <br>
                                <div v-if="Totales.length>0 " style="width:100%;height:100%;">
                                    <TTotal
                                    :Datos= this.Totales 
                                    :EtiquetaArea = this.NombreTotales
                                    :EtiquetaAnio = this.Etiqueta.AnioReporte
                                    :Ingreso = false
                                    :Solicitud = true
                                    :HNombre= this.NombreAreas
                                    :ShowGrafica = false></TTotal>
                                </div>
                                <div v-if="SolicitudArea.length > 0">
                                </div>
                            </div>
                            <div class="text-right">
                                <button class="btn btn-sm btn-custom" @click='ImprimirReporteJuzgado()' >Imprimir Reporte</button>      
                            </div>
                        
                        </div>
                        <div class="tab-pane fade" id="Publicas" role="tabpanel" aria-labelledby="profile-tab">
                            <div id="Resultado_Publico_id">
                                <br/>
                                <div v-if="Publicas.length > 0">
                                <PSolicitudesArea 
                                :Datos= this.Publicas 
                                :EtiquetaArea= this.Etiqueta.AreaReporte 
                                :EtiquetaAnio= this.Etiqueta.AnioReporte
                                :Ingreso = false
                                :Solicitud = true
                                :HNombre= this.headName
                                :ShowGrafica = true></PSolicitudesArea>
                                </div>
                                <br/>
                                <div v-if="Sedes_Publicas.length > 0">
                                    <PSedes
                                    :Datos= this.Sedes_Publicas
                                    :EtiquetaArea = this.NombreSede
                                    :EtiquetaAnio = this.Etiqueta.AnioReporte
                                    :Ingreso = false
                                    :Solicitud = true
                                    :HNombre= this.NombreSede
                                    :ShowGrafica = false></PSedes>
                                </div>
                                <br/>
                                <div v-if="Estatus_Publicas.length>0 ">
                                    <PTotal
                                    :Datos= this.Estatus_Publicas 
                                    :EtiquetaArea = this.NombreTotales
                                    :EtiquetaAnio = this.Etiqueta.AnioReporte
                                    :Ingreso = false
                                    :Solicitud = true
                                    :HNombre= this.NombreAreas
                                    :ShowGrafica = false></PTotal>
                                </div>
                            </div>
                                <div v-if="Publicas.length > 0">
                                    <div class="text-right">
                                        <button class="btn btn-sm btn-custom" @click='ImprimirReportePublico()' >Imprimir Reporte</button>      
                                    </div>
                                </div>
                        </div>
                        <div class="tab-pane fade" id="Totales" role="tabpanel" aria-labelledby="profile-tab">
                            <div id="Resultado_Totales_Areas_id">
                                <br/>
                                <div v-if="AreasTotales.length>0">
                                    <PAreasTotales
                                    :Datos= this.AreasTotales 
                                    :EtiquetaArea = this.NombreTotalesAreas
                                    :EtiquetaAnio= this.Etiqueta.AnioReporte
                                    :Ingreso = false
                                    :Solicitud = true
                                    :HNombre= this.Reporte
                                    :ShowGrafica = true>
                                    </PAreasTotales>
                                </div>
                                 
                            </div>
                            <div v-if="AreasTotales.length > 0">
                                <br>
                                <div class="text-right">
                                    <button class="btn btn-sm btn-custom" @click='ImprimirReporteTotalesAreas()' >Imprimir Reporte</button>      
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import Tablas from '@/components/ArchivoJudicial/Comun/TablasIngreso.vue'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'


export default {
    components:{
        CAreas: catalogos.ArchivoJudicial.C001Areas,
        TSolicitudesArea: Tablas,
        TSedes: Tablas,
        TTotal: Tablas,
        PSolicitudesArea: Tablas,
        PSedes: Tablas,
        PTotal: Tablas,
        PAreasTotales: Tablas

    },
     data(){
        return{
            Busqueda: {
                Anio: parseInt(moment().format('YYYY'))
            },
            SolicitudArea: [],
            Sedes: [],
            Totales: [],
            Publicas : [],
            Sedes_Publicas: [],
            Estatus_Publicas : [],
            AreasTotales : [],
            Etiqueta:{
                AreaReporte: "",
                AnioReporte: 0
            },
            headName: "",
            NombreSede: "",
            NombreTotales: "",
            NombreAreas:"",
            Reporte: "Areas",
            NombreTotalesAreas: "Totales en Areas",
            enumeraciones,
            parametros_Area: {
              areaId: -1,
              conMaterias: true,
              Nombre: ""
            },
            Busqueda: {
                Anio: parseInt(moment().format('YYYY'))
            },
        }
    },
     methods :{
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.parametros_Area.Nombre = datos[0].target.selectedOptions[0].text;
        },
        ObtenerReporte(){
            this.SolicitudArea = [];
            this.Sedes = [];
            this.Totales = [];
            if(this.ValidarDatos())
            {
                var peticion = {
                    "AreaId": this.parametros_Area.areaId,
                    "Año": this.Busqueda.Anio
                }
                
                
                this.Etiqueta.AreaReporte = this.parametros_Area.Nombre;
                this.Etiqueta.AnioReporte = this.Busqueda.Anio;
                this.headName = "Año";
                this.NombreSede = "Sede de Archivo";
                this.NombreTotales = "por estatus";
                this.NombreAreas ="Estatus"
                
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.SolicitudesAnual, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                        if(respuesta.data.SiHayError)
                        {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                        else
                        {   
                            this.SolicitudArea = respuesta.data.Solicitudes;
                            this.Sedes = respuesta.data.Sedes;
                            this.Totales = respuesta.data.Totales;
                            this.Publicas = respuesta.data.Publicas_Solicitudes;
                            this.Sedes_Publicas = respuesta.data.Publicas_Sedes;
                            this.Estatus_Publicas= respuesta.data.Publicas_Estatus;
                            this.AreasTotales = respuesta.data.TotalesAreasAnual;
                        
                            comun.SeEstaCargandoInformacion(false);

                            if (this.SolicitudArea.length == 0 && this.Sedes.length== 0 && this.Totales.length==0)
                            {
                                comun.mensajeDeAlerta("No hay Resultados para esta Área", null, null);
                            }
                        }
                        comun.SeEstaCargandoInformacion(false);
                        })
                        .catch(excepcion => {
                            console.log(excepcion);
                            console.log("fallo por parametros");
                            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }); 
            }
        },
        ValidarDatos(){
            if(this.parametros_Area.areaId == -1)
            {
              comun.mensajeDeAlerta("Seleccione una Área para obtener Reporte.", null, null);
              return false;
            }
            if(this.Busqueda.Anio == 0 || this.Busqueda.Anio == null)
            { comun.mensajeDeAlerta("Indicar año de ingreso correcto.", null, null);
                    return false;
            };
            
            if(this.Busqueda.Anio >parseInt(moment().format('YYYY')))
            { comun.mensajeDeAlerta("El año de ingreso no puede ser mayor al año corriente", null, null);
                    return false;
            };
            
            return true; 
        },
        ImprimirReporteJuzgado(){
          var printWin = window.open('', '_blank', 'width=500,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="row d-flex">')
            printWin.document.write('<div class="col-12">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('           <div class="form-group col-3 align-self-center">');
            printWin.document.write('       <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">SOLICITUDES ANUAL POR AREA</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</div>');


            printWin.document.write('<div class="row col-12">');

            var areaImpresion = document.getElementById('Resultado_Juzgado_id').innerHTML;
            printWin.document.write(areaImpresion);

            printWin.document.write('</div>');
            printWin.document.write('</div>');

            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        ImprimirReportePublico(){
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="row d-flex">')
            printWin.document.write('<div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">SOLICITUDES PÚBLICAS ANUAL POR AREA</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</div>');

            printWin.document.write('<div class="area">');
            
            var areaImpresion = document.getElementById('Resultado_Publico_id').innerHTML;
            printWin.document.write(areaImpresion);
            
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        ImprimirReporteTotalesAreas(){
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="row d-flex">')
            printWin.document.write('<div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">');
            printWin.document.write('   <div class="area">');
            printWin.document.write('       <div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">SOLICITUDES TOTALES '+ this.Etiqueta.AnioReporte + '</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('</div>');

            printWin.document.write('<div class="area">');
            
            var areaImpresion = document.getElementById('Resultado_Totales_Areas_id').innerHTML;
            printWin.document.write(areaImpresion);
            
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</div>');
            printWin.document.write('</body></html>');
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        }
        
    }

}
</script>

<style scoped>
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }

</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Reportes/SolicitudesAnual.vue